import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Start from "../Start/start";
import Cursos from "../Curso/cursos";
import Ayuda from "../Ayuda/ayuda";
import Anuncios from "../Anuncio/anuncios";
import Suscriptor from "../Suscriptor/suscriptor";
import Listas from "../Video/listas";
import Validar from "../Suscriptor/validar";
import About from "../About/about";
import Notfound from "../Notfound/notfound";
//import ReactGA from "react-ga4";

/*import Login from "../Login/login";
import Registro from "../Registro/registro";
import Carrito from "../Carrito/carrito";
import Destacadas from "../Pelicula/destacadas";
import Peliculas from "../Pelicula/peliculas";
import Favoritos from "../Favorito/favoritos";
import Buscar from "../Pelicula/buscar";
*/
const Body = () => {
  useEffect(() => {
    //ReactGA.send(window.location.pathname);
  }, []);
  return (
    <section>
      <Routes>
        <Route path="/" exact element={<Start />}></Route>
        <Route path="/start" exact element={<Start />}></Route>
        <Route path="/cursos" exact element={<Cursos />}></Route>
        <Route path="/about" exact element={<About />}></Route>
        <Route path="/ayuda" exact element={<Ayuda />}></Route>
        <Route path="/anuncios" exact element={<Anuncios />}></Route>
        <Route path="/suscriptor" exact element={<Suscriptor />}></Route>
        <Route path="/videos" exact element={<Listas />}></Route>
        <Route path="/validar/:valcode" exact element={<Validar />}></Route>
        <Route path="/*" element={<Notfound />}></Route>
      </Routes>
    </section>
  );
};

export default Body;
